import { Link, useHistory } from "react-router-dom";
import "../../style/admin.css";
import "../../style/supervisor.css";
import { useAuth } from "../../context/GlobalContext";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import homePage from "./HomePage.module.css";
import useConfirm from "../Control/useConfirm";
import { getTilesByUserType } from "../../constants/tilesConfig";
import TileRenderer from "../Control/TileRenderer";

const Supervisor = () => {
  const { state, logout } = useAuth();
  const history = useHistory();
  const access = state.user?.access || [];
  const [Dialog, confirmLogoutUser] = useConfirm(
    "LOG OUT",
    "Are you sure you want to log out?",
  );

  const logoutUser = async () => {
    const ans = await confirmLogoutUser();
    if (ans) {
      logout();
      history.push("/");
    }
  };

  if (state.user?.userType === 3) {
    const supervisorTiles = getTilesByUserType(3);

    return (
      <>
        <main className={`${homePage.container} ${homePage.main}`}>
          {supervisorTiles.map(tile => {
            // Check if user has access to this tile
            const hasAccess = access.some((obj) => obj.id === tile.id);

            // Only render if user has access
            if (!hasAccess) {
              return null;
            }

            return (
              <TileRenderer
                key={tile.id}
                tile={tile}
              />
            );
          })}

          {/* Logout Tile */}
          <div>
            <Link
              style={{ cursor: "pointer" }}
              to="/"
              className="panel"
              onClick={logoutUser}
            >
              <ExitToAppIcon style={{ fontSize: "3rem", color: "maroon" }} />
            </Link>
            <p className="card-btn-para">
              Logout <span className="card-btn-span">Aqua</span>
            </p>
          </div>
        </main>
        <Dialog />
      </>
    );
  } else {
    return (
      <div>
        <h1>Page Not Found</h1>
      </div>
    );
  }
};

export default Supervisor;
